import { Controller } from "@hotwired/stimulus"

const openClassname = "has-load-more-on-y--visible"

export default class extends Controller {
  static targets = ["shrinked", "button"]

  connect() {
    this.isOpen = this.shrinkedTarget.classList.contains(openClassname)
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.shrinkedTarget.classList.toggle(openClassname, this.isOpen)
    this.#updateText()
  }

  #updateText() {
    if (this.isOpen) {
      this.buttonTarget.innerHTML = this.buttonTarget.dataset.showLess

      return
    }

    this.buttonTarget.innerHTML = this.buttonTarget.dataset.showMore
  }
}
